import { render, staticRenderFns } from "./TextListen.vue?vue&type=template&id=46872f6f&scoped=true&"
import script from "./TextListen.vue?vue&type=script&lang=js&"
export * from "./TextListen.vue?vue&type=script&lang=js&"
import style0 from "./TextListen.vue?vue&type=style&index=0&id=46872f6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46872f6f",
  null
  
)

export default component.exports